// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1iJ7W","question":"Question_question__3zJVl","description":"Question_description__FCJAh"};